export const providerSearchAccent = {
  50: "#E6E6D5",
  900: "#102832",
} as const;
